import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	loadingLabel: {
		id: 'navigation.global-invite.loading-visually-hidden-label',
		description: 'Visually hidden text to indicate the invite people UI is loading.',
		defaultMessage: 'Loading',
	},
});
